(function () {
    window.NewsGraph = window.NewsGraph || {};

    window.NewsGraph.runForce = function(nodes, links, meshMap) {
        const THREE  = window.THREE;

        const pos = {};
        nodes.forEach(n => { pos[n.id] = meshMap[n.id].object3D.position.clone(); });

        const REPULSION = 14.0;
        const LINK_K    = 0.05;
        const CENTER_K  = 0.015;
        const ITERS     = 200;

        const degreeMap = {};
        nodes.forEach(n => { degreeMap[n.id] = 0; });
        links.forEach(l => {
            if (degreeMap[l.source] !== undefined) degreeMap[l.source]++;
            if (degreeMap[l.target] !== undefined) degreeMap[l.target]++;
        });
        const maxDeg = Math.max(1, ...Object.values(degreeMap));

        const counts  = nodes.map(n => n.article_count || 0);
        const minCnt  = Math.min(...counts);
        const maxCnt  = Math.max(...counts);
        const normSize = {};
        nodes.forEach(n => {
            normSize[n.id] = maxCnt > minCnt
                ? ((n.article_count || 0) - minCnt) / (maxCnt - minCnt)
                : 0.5;
        });

        for (let iter = 0; iter < ITERS; iter++) {
            const alpha   = 1 - iter / ITERS;
            const forces  = {};
            nodes.forEach(n => { forces[n.id] = new THREE.Vector3(); });

            for (let i = 0; i < nodes.length; i++) {
                for (let j = i + 1; j < nodes.length; j++) {
                    const a    = nodes[i].id;
                    const b    = nodes[j].id;
                    const diff = pos[a].clone().sub(pos[b]);
                    const d2   = Math.max(diff.lengthSq(), 0.01);
                    const fv   = diff.normalize().multiplyScalar(REPULSION / d2);
                    forces[a].add(fv);
                    forces[b].sub(fv);
                }
            }

            links.forEach(link => {
                const p1 = pos[link.source];
                const p2 = pos[link.target];
                if (!p1 || !p2) return;
                const diff  = p2.clone().sub(p1);
                const len   = diff.length();
                const ideal = 2.2 + (1 - link.strength / 100) * 1.5;
                const delta = (len - ideal) * LINK_K;
                const fv    = diff.normalize().multiplyScalar(delta);
                forces[link.source].add(fv);
                forces[link.target].sub(fv);
            });

            nodes.forEach(n => {
                const isNarrative = window.NewsGraph.NARRATIVE_TYPES.has(n.type);
                const degNorm  = (degreeMap[n.id] || 0) / maxDeg;
                const weight   = 1 + degNorm * 1.5 + normSize[n.id] * 1.0;
                
                if (isNarrative) {
                    forces[n.id].addScaledVector(pos[n.id], -CENTER_K * weight);
                } else {
                    const d = pos[n.id].length();
                    const R_orbit = 4.5;
                    if (d > 0.01) {
                        const factor = (d - R_orbit) / d;
                        forces[n.id].addScaledVector(pos[n.id], -CENTER_K * weight * factor);
                    } else {
                        forces[n.id].add(new THREE.Vector3(Math.random() - 0.5, Math.random() - 0.5, Math.random() - 0.5).normalize().multiplyScalar(0.1));
                    }
                }
            });

            nodes.forEach(n => {
                pos[n.id].addScaledVector(forces[n.id], alpha);
            });
        }

        nodes.forEach(n => {
            meshMap[n.id].object3D.position.copy(pos[n.id]);
        });
    };
})();
